export default "__VITE_ASSET__b74d5b5a__"